/* eslint-disable react/no-unescaped-entities */
import React from 'react';

import {
  ScrollToTopOnMount,
  Body,
  ExtendedFlex,
  Heading,
} from '../coreui';

const linkStyle = {
  color: '#176DB6',
  textDecoration: 'none',
};
const italicized = {
  fontWeight: 'bold',
};

export const ElectronicDisclaimer = () => {
  return (
    <ExtendedFlex
      bg="#FFFFFF"
      flexDirection="column"
      justify="center"
      align="left"
      px="10%"
      py="5%"
      w={1}
    >
      <ScrollToTopOnMount />
      <Body type="B3">
        <Heading type="H6">Electronic Consent and Delivery of Documents</Heading>
        <br /><br />
        I agree that any time I click or have clicked on an <Body type="B3" style={italicized} >(“I Agree,”)</Body><Body type="B3" style={italicized} >(“I Consent”)</Body> or other similarly worded button or entry field with my mouse, keystroke or other device, my agreement or consent is legally binding and enforceable against me and is the legal equivalent of my handwritten signature on an agreement that is printed on paper. I agree to be bound by any affirmation, assent or agreement that I transmit, or have transmitted, to or through this website (the
        <Body type="B3" style={italicized} >{' “Platform”'}</Body>) by computer or other electronic device, including
        internet, telephonic and wireless devices, including but not limited to any consent
        I give or have given to receive communications from
        <a style={linkStyle} href="https://realtymogul.com"> RealtyMogul, Co</a>. or any of its affiliates (<Body type="B3" style={italicized} >“RealtyMogul”</Body>) solely through electronic transmission. I agree that RealtyMogul may create and store a version of any document to which I have provided electronic consent with my simulated signature affixed thereto and that such version shall be deemed an executed copy and a valid record of the agreed to document with the same effect as if such document had been originally executed by me.
        <br /><br />
        I understand that, to the fullest extent permitted by law, any notices, disclosures, forms, privacy statements, reports or other communications, including any tax-related information or documents to the extent provided below (collectively, <Body type="B3" style={italicized} >“Communications”</Body>), regarding the investments available on the Platform, and my investment in any such investments, may be delivered by electronic means, such as by e-mail or through  <a style={linkStyle} href="https://realtymogul.com">RealtyMogul.com</a>. I consent to electronic delivery as described in the preceding sentence. In so consenting, I acknowledge that e-mail messages are not secure and may contain computer viruses or other defects, may not be accurately replicated on other systems or may be intercepted, deleted or interfered with, with or without the knowledge of the sender or the intended recipient. I also acknowledge that an e-mail from RealtyMogul may be accessed by recipients other than me and may be interfered with, may contain computer viruses or other defects and may not be successfully replicated on other systems. I understand that RealtyMogul gives no warranties in relation to these matters.
        <br /><br />
        I consent to the delivery of tax documents (such as Internal Revenue Service (<Body type="B3" style={italicized} >“IRS”</Body>) Form 1099-INT) through <a style={linkStyle} href="https://realtymogul.com">RealtyMogul.com</a>. I understand that I may withdraw this consent before my tax document is furnished. In providing this consent, I also acknowledge that I have received RealtyMogul’s Information on the Electronic Delivery of Tax Documents, included below.
        <br /><br />
        I further understand and agree to each of the following:
        <br /><br />
        <ul>
          <li>As long as my consent remains in effect, RealtyMogul may provide
            all Communications to me electronically in lieu of providing paper Communications.
          </li>
          <li><Body type="B3" style={italicized} >Hardware and software that I will need</Body>.
            Electronic Communications may be provided to
            me via e-mail and/or the Platform. In order to view and retain the Communications,
            my computer hardware and software must, at a minimum, be capable of accessing the
            Internet, with connectivity to an Internet Service Provider or any other capable
            communications medium, and with software capable of viewing and printing a *.pdf file
            created by Adobe Acrobat. Further, I must have a personal e-mail address capable of
            sending and receiving e-mail messages to and from RealtyMogul. To print the documents,
            I will need access to a printer compatible with my hardware and the required software.
          </li>
          <li>If these software or hardware requirements change in the future, RealtyMogul will
            notify me through the Platform.
          </li>
          <li>To facilitate these services, I must provide RealtyMogul with my current e-mail
            address and update that information as necessary. Unless otherwise required by
            law, I will be deemed to have received any electronic Communications that
            are sent to the most current e-mail address that I have
            provided to RealtyMogul.
          </li>
          <li>RealtyMogul will not assume liability for non-receipt
            of notification of the availability of electronic
            Communications in the event my e-mail address on
            file is invalid, my e-mail or Internet service
            provider filters the notification as “spam” or
            “junk mail,” there is a malfunction in my
            computer, browser, Internet service and/or
            software, or for any other reasons beyond the
            control of RealtyMogul.
          </li>
          <li>
            I may withdraw my consent to receive Communications in
            electronic form by calling RealtyMogul at
            <a style={linkStyle} href="tel:1-877-977-2776"> 877.977.2776</a>.
            If I withdraw my consent to receive Communications in
            electronic form, RealtyMogul may, at its option and in
            its sole discretion, (A) terminate my account with RealtyMogul
            that was created through the Platform (<Body type="B3" style={italicized} >"My Account"</Body>), (B)
            restrict or limit the actions I may take through or with
            respect to My Account, including, but not limited to,
            restricting my ability to purchase RealtyMogul investment
            through My Account, and (C) charge me a fee of $5 for each
            paper copy of each Communication that would have been
            provided to me electronically if I had not withdrawn my consent.
            Any withdrawal of my consent to receive electronic Communications
            will not affect or impact in any way the terms of this Agreement
            or my agreement to the Terms of Use Agreement for the Platform.
          </li>
        </ul>
        <br />
        <Heading type="H6">Information on Electronic Delivery of Tax Documents</Heading>
        <br /><br />
        These provisions relate to my consent above to RealtyMogul’s provision of tax
        documents to me electronically. Prior to furnishing the tax documents electronically,
        the IRS requires that RealtyMogul provide each investor with the following information:
        <br /><br />
        <ul>
          <li>If I do not consent to receive the tax document electronically,
            a paper copy will be provided.
          </li>
          <li>My consent continues for every tax year until I withdraw my consent.</li>
          <li>If these software or hardware requirements change in the future, RealtyMogul will
            notify me through the Platform.
          </li>
          <li>I may log into My Account at <a style={linkStyle} href="https://realtymogul.com">RealtyMogul.com </a>
            to access and print my tax documents.
            I may need Adobe Acrobat Reader to open
            the document and a device connected to my computer that can print.
            In the event a tax document is too large to open in the browser,
            I will be prompted by a dialog box to save the file to a location on my
            computer and open it using Acrobat Reader.
          </li>
          <li>To withdraw consent, I may call RealtyMogul at
            <a style={linkStyle} href="tel:1-877-977-2776"> 877.977.2776 </a>
            to request to withdraw my consent.
          </li>
          <li>
            If My Account is closed, my request for electronic delivery of tax documents
            will automatically terminate, and I will receive a paper copy of my tax
            documents by mail at the address that I have provided to RealtyMogul.
          </li>
          <li>
            I may update my contact information by calling RealtyMogul at
            <a style={linkStyle} href="tel:1-877-977-2776"> 877.977.2776</a>.
          </li>
          <li>
            My tax documents are maintained for 10 years on
            <a style={linkStyle} href="https://realtymogul.com"> RealtyMogul.com </a>
            in case I ever need to access them again.
          </li>
        </ul>
      </Body>
    </ExtendedFlex>
  );
};
export default ElectronicDisclaimer;
